import { render } from "./sidebar-email.vue?vue&type=template&id=1331962c"
import script from "./sidebar-email.vue?vue&type=script&lang=js"
export * from "./sidebar-email.vue?vue&type=script&lang=js"
script.render = render

export default script